import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import FormController from './FormController/formController';
import Login from './Authentication/Login'
import BuyNow from './Authentication/Buynow'
import SimulanisLogin from './Authentication/SimulanisLogin'
import LeftNavBar from './Navbar/LeftNavbar'
import TopNavBar from './Navbar/TopNavBar'
import DashboardController from './FormController/dashboardController'
import CallingChannel from './FormController/VideoChat/CallingChannel'
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/icons.css';
import './assets/css/style.css';
import './assets/css/style_custom.css';
import './assets/css/lightdarkmode.css'
import { jwt, ud, SERVER_IP, PORT, changeUserInfo, Communication_obj, auth_response_flow, UpdateLicense } from './Server'
import { SOCKET, UpdateSocket } from './SocketData'
import AcessDenied from './FormController/SplashPage/AcessDenied'
import Authloading from './FormController/SplashPage/authLoading'
import axios from 'axios';
import Projects from './FormController/Projects/project';
import UserState from './context/UserState';
import { Videocall, Audiocall } from './FormController/VideoChat/Call';
// import socketIo from "socket.io-client";

var socket
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      to_calling_obj: undefined,
      callChannel: Communication_obj,
      auth_wait: false,
      liveusers: []
    }
  }
  componentDidMount() {
    let _this = this
    if (jwt == undefined || jwt == "") {
      this.setState({ auth_wait: true })
      this.authanticate();
    }
    if (jwt) {
      if (ud.c_id != 0) {
        UpdateLicense();
      }
    }

    if (this.state.callChannel) {
      if (jwt) {
        if (ud) {
          if (ud.usertype === 3) {
            // socket = socketIo(SERVER_IP, { transports: ["websocket"] });
            socket = require('socket.io-client')(`${SERVER_IP}`);
            
            _this.emit_I_AM_ONLINE();

            socket.on('reconnect', function () {
                _this.emit_I_AM_ONLINE();
            })

            socket.on("live_users_list", function (data) {
              _this.setState({ liveusers: data.liveusers });
            })

            UpdateSocket(socket);
            this.setState({ socket: socket });
          }
        }
      }
    }
  }

  authanticate = () => {
    var req_data = {}
    let _this = this
    axios.post(`${SERVER_IP}/reauthenticate`, req_data, { withCredentials: true })
      .then(function (response) {
        if (response.data.error == false) {
          changeUserInfo(response.data.JWT_token, response.data.details)
          window.location.href = '/dashboard'
        }
        else {
          _this.setState({ auth_wait: false })
          let localName = localStorage.getItem('light_DarkMode')
          sessionStorage.clear();
          localStorage.clear();
          localStorage.setItem('light_DarkMode', localName)
          if (!['/login', '/simulanislogin', '/', '/buynow'].includes(window.location.pathname)) {
            window.location.href = '/login'
          }
          // if (window.location.pathname != "/login") {
          //   if (window.location.pathname != "/simulanislogin") {
          //     window.location.href = '/login'
          //   }
          // }

          // DO Nothing
        }
      })
      .catch(function (error) {
        _this.setState({ auth_wait: false })
      });
  }
  toCalling = (to_calling_obj) => {
    this.setState({ to_calling_obj: to_calling_obj })
  }
  //Date Format 2022-07-27 
  formatDate = (date) => {
    let d = new Date(date);
    let month = (d.getMonth() + 1).toString();
    let day = d.getDate().toString();
    let year = d.getFullYear();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    return [year, month, day].join('-');
  }
  emit_I_AM_ONLINE = () => {
    var json_data =
    {
      user_id: ud.id,
      session_id: ud.session_id,
      receive_data: true,
      datetime: this.formatDate(new Date())+" "+new Date().toLocaleTimeString()
    }
    socket.emit("i_am_online", json_data)
  }

  render() {
    return (
      <UserState>
        {window.location.href != `${process.env.REACT_APP_LIVE_URL}videocall` && window.location.href != `${process.env.REACT_APP_LIVE_URL}annotation` &&
          <div className="xp-vertical">
            <div id="xp-container">
              {this.state.auth_wait ?
                <Authloading />
                :
                <>
                  <Router >
                    {jwt ? <LeftNavBar socket={socket} toCalling={this.toCalling} /> : null}
                    <div class="xp-rightbar">
                      {jwt ? <TopNavBar /> : null}
                      {this.state.callChannel ? jwt ? ud ? ud.usertype === 3 ? <CallingChannel socket={socket} to_calling_obj={this.state.to_calling_obj} /> : null : null : null : null}
                      <Switch>
                        {jwt ?
                          <>
                            <Route path="/dashboard" component={DashboardController} />
                            <Route path="/create/:formtype" component={(props) => <FormController {...props} socket={socket} toCalling={this.toCalling} />} />
                            <Route path="/call/:room_id"><Audiocall socket={socket} liveusers={this.state.liveusers} /></Route>
                          </>
                          :
                          <>
                            <Route path="/" component={Login} exact />
                            <Route path="/buynow" component={BuyNow} />
                            <Route path="/login" component={Login} />
                            <Route path="/simulanislogin" component={SimulanisLogin} />
                            <Route path="/projects" component={Projects} />
                          </>
                        }
                      </Switch>
                    </div>
                  </Router>
                </>
              }
            </div>
          </div>
        }
      </UserState>
    );
  }
}


export default App;